<template>
    <the-mask v-if="withMask" :mask="mask" :masked="true" class="input-text input-date" type="text" ref="dateInput" autocomplete="off"
              :name="name"
              :value="value"
              @change="$emit('change')"
              @blur.native="onBlur"
              @focus="$emit('focus')"></the-mask>
     <input v-else class="input-text input-date" type="text" ref="dateInput" autocomplete="off"
           :name="name"
           :value="value"
           @change="$emit('change')"
           @blur="onBlur"
           @focus="$emit('focus')"/>
</template>

<script>
    import $ from 'jquery'
    import datepicker from '../assets/Bootstrap/bootstrap-datepicker.min'
    import datepickerRu from '../assets/Bootstrap/bootstrap-datepicker.ru'

    export default {
        name: "input-date",

        props: ['name', 'value', 'withMask', 'todayHighlight'],

        data(){
            return {
                mask: '##.##.####',
                changed: false
            }
        },

        methods:{
            // _updateDate(){
            //     this.$emit('input', this.$refs.dateInput.value);
            //     console.info('_updateDate -> this.$refs.dateInput.value', this.$refs.dateInput.value)
            // },

            onBlur(){
                let vm = this;
                //console.info('onBlur, [vm.value, $(vm.$el).val()]', [vm.value, $(vm.$el).val()]);
                if((vm.value || '') != $(vm.$el).val()) {
                    this.$emit('input', $(vm.$el).val());
                    this.changed = true;
                }else{
                    this.changed = false;
                }
            },

            setDate(date){
                $(this.$el).datepicker('update', date);
            }
        },

        mounted () {
            let vm = this;
            this.$nextTick(() => {
                $(vm.$el).datepicker({
                    language: 'ru',
                    autoclose: true,
                    todayHighlight: vm.todayHighlight
                }).on('changeDate', function(val){
                    //console.info('changeDate, [$(vm.$el).val(), this.changed]', [$(vm.$el).val(), this.changed]);
                    if(!this.changed) {
                        vm.$emit('input', $(vm.$el).val());
                    }else{
                        this.changed = false;
                    }
                });
            })
        },

        destroyed(){
            $(this.$el).datepicker('destroy');
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/InputDate.vue